import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';

export default function sale() {
  let saleSlider = document.querySelector('.sale__slider');

  if (!saleSlider) return;

  const swiper = new Swiper('.sale__slider', {
    autoplay: {
      delay: 3000,
    },
    slidesPerView: 1,
    spaceBetween: 108,
    loop: true,
    speed: 1100,
    modules: [Pagination, Autoplay],
    pagination: {
      el: ".sale .swiper-pagination",
      dynamicBullets: false,
      clickable: true,
    },
    breakpoints: {
      315: {
        slidesPerView: 1,
          },
      580: {
        slidesPerView: 1,
      },
      986: {
        slidesPerView: 2,
      },
    },
  });
}